import React, { createContext, useContext, useState, useEffect } from 'react';


export const BASE_URL = 'https://ss.tanveersingh.online';
const API = `${BASE_URL}/api/blogs.php`;
const BlogContext = createContext(); 
// ... rest of your file stays exactly the same
export function BlogProvider({ children }) {
  const [blogs, setBlogs] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetch(API)
      .then((r) => r.json())
      .then((data) => {
        setBlogs(
          Array.isArray(data)
            ? data.map((b) => ({ ...b, category: b.category || '', publish_date: b.publish_date || '' }))
            : []
        );
      })
      .catch(() => setBlogs([]))
      .finally(() => setLoading(false));
  }, []);

  const apiFetch = async (url, options) => {
    const res  = await fetch(url, options);
    const text = await res.text();
    let json;
    try { json = JSON.parse(text); }
    catch { throw new Error('Server error: ' + text.substring(0, 300)); }
    if (!res.ok || json.success === false)
      throw new Error(json.message || json.error || `HTTP ${res.status}`);
    return json;
  };

  const addBlog = async (blog) => {
    const data = await apiFetch(API, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(blog),
    });
    setBlogs((prev) => [data.blog ?? { ...blog, id: data.id }, ...prev]);
  };

  const updateBlog = async (id, updated) => {
    await apiFetch(`${API}?id=${id}`, {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(updated),
    });
    setBlogs((prev) => prev.map((b) => (b.id === id ? { ...b, ...updated } : b)));
  };

  const deleteBlog = async (id) => {
    await apiFetch(`${API}?id=${id}`, { method: 'DELETE' });
    setBlogs((prev) => prev.filter((b) => b.id !== id));
  };

  return (
    <BlogContext.Provider value={{ blogs, loading, addBlog, updateBlog, deleteBlog }}>
      {children}
    </BlogContext.Provider>
  );
}

export function useBlogs() { return useContext(BlogContext); }